var PES = PES || {};

PES.SectionModel = function (identifier, validateFunction, validated) {
    var self = this;
    self.display = ko.observable(true);
    self.identifier = identifier;
    self.validate = validateFunction;
    self.isCurrentLogicalStep = ko.observable(false);

    if (validated != null && validated !== undefined) {
        self.validated = validated;
    }
    else {
        self.validated = ko.observable(false);
    }

    return self;
};